export interface EntityRemindersDataModel {
  todayCount: number;
  thisWeekCount: number;
  nextWeekCount: number;
}